export const parameterTableColumns: any = [
  {
    display_name: "",
    key: "select",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
      width: "5%",
    },
    _config: {
      type: "checkbox",
      displayInColumn: false,
    },
  },
  {
    display_name: "Parameter Name/ Key",
    key: "name",
    headerStyles: {
      background: "#7593F2",
      width: "45%",
    },
  },
  {
    display_name: "Parameter Type",
    key: "type",
    headerStyles: {
      background: "#7593F2",
      width: "45%",
    },
  },
  {
    key: "edit",
    display_name: "",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "5%",
      color: "#fff",
    },
    _config: {
      displayInColumn: false,
      type: "svg",
      value: "../../../../assets/images/table/table-item-edit.svg",
      isClickable: "true",
    },
  },
];


export const parameterTableData: any = [
    {
        name: "Parameter_1",
        type: "String",
    },
    {
        name: "Parameter_2",
        type: "Query",
    },
    {
        name: "Parameter_3",
        type: "Query",
    },
    {
        name: "Parameter_4",
        type: "String",
    },

]